import { isBefore } from 'date-fns';
import { ValidateIsStartDateBeforeEndDateParams } from '../types/validateIsStartDateBeforeEndDate.utils.types';

export const isStartDateBeforeEndDate = ({
  startDate,
  endDate,
}: ValidateIsStartDateBeforeEndDateParams): boolean => {
  if (!startDate || !endDate) {
    return true;
  }

  return isBefore(new Date(startDate), new Date(endDate));
};
